module.exports = __webpack_public_path__ + "static/media/ivan4.bc8c5162.jpg";